export enum AlarmStatus {
	OPEN = 'Open',
	ACKNOWLEDGED = 'Acknowledged',
	VERIFIED = 'Verified',
	ESCALATED = 'Escalated',
	RESOLVED = 'Resolved',
	FALSE = 'False',
	MAINTENANCE = 'Maintenance'
}
